import { render, staticRenderFns } from "./DriverDetail.vue?vue&type=template&id=20067004&scoped=true"
import script from "./DriverDetail.vue?vue&type=script&lang=js"
export * from "./DriverDetail.vue?vue&type=script&lang=js"
import style0 from "./DriverDetail.vue?vue&type=style&index=0&id=20067004&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20067004",
  null
  
)

export default component.exports